import { getEnv } from './envConfig'
let env = getEnv()

export const ENDPOINT = env.ENDPOINT
export const KEYCLOAK_URL = env.KEYCLOAK_URL

export const INCIDENT_SUMMARY = ENDPOINT + '/api/dashboard/incidents/summary'
export const INCIDENT_REPORT = ENDPOINT + '/api/dashboard/incidents/reported'
export const INCIDENT_BY_LOCATION = ENDPOINT + '/api/dashboard/incidents/location-stats'
export const IMPORTANT_REPORT = ENDPOINT + '/api/dashboard/incidents/status-counters'
export const INCIDENT_STATUS_COUNT = ENDPOINT + '/api/dashboard/incidents/status-count'
export const INCIDENT_TYPE_COUNT = ENDPOINT + '/api/dashboard/incidents/type-counts-with-rank'

export const COMPANIES = ENDPOINT + '/api/companies'
export const BRANCHES = ENDPOINT + '/api/branches'
export const LOCATIONS = ENDPOINT + '/api/locations'
export const DEPARTMENT = ENDPOINT + '/api/departments'
export const DESIGNATION = ENDPOINT + '/api/designations'


export const INCIDENTS = ENDPOINT + '/api/incidents'
export const INCIDENT_ACTIONS = ENDPOINT + '/api/actions'
export const INCIDENT_ANALYSIS = ENDPOINT + '/api/analyses'
export const INCIDENT_STATUSES = ENDPOINT + '/api/incident-statuses'


export const INCIDENT_TYPES = '/api/incident-types';
export const INCIDENT_TYPE_QUESTIONS = '/api/incident-type-questions';
export const SUB_LOCATIONS = '/api/sub-locations';
export const SEVERITY_IMPACTS = '/api/severity-impacts';
export const INCIDENT_QUASTIONS_ANSWERS = '/api/incident-answers';

export const RISK_ASSESSMENT = '/api/risk-analyses';
export const RISK_ASSESSMENT_DETAILS = '/api/risk-analysis-details';
export const HAZARD_GROUPS = '/api/hazard-groups';
export const HAZARDS = '/api/hazards';
export const RISK_TASKS = '/api/risk-tasks';
export const RISK_CONTROLLER = '/api/risk-controllers-setups';
export const RISIDUAL_RISK = '/api/risidual-risk-analyses';

export const AUDITS = '/api/audits';
export const AUDIT_SECTION = '/api/audit-sections';
export const AUDIT_QUESTIONS= '/api/audit-questions';
export const AUDIT_ASSINGS= '/api/audit-assigns';
export const AUDIT_SECTION_ASSINGS= '/api/audit-section-assigns';
export const AUDIT_ANSWERS= '/api/audit-answers';

export const TRAINING_CATEGORIES = ENDPOINT + '/api/training-categories'
export const TRAINING_TEAMS = ENDPOINT + '/api/team-setups'
export const TEAM_MEMBERS = ENDPOINT + '/api/teammembers'
export const TRAINING_SETUPS = ENDPOINT + '/api/training-setups'
export const USERS = '/api/users';
export const ROLES = '/api/roles';
